module.exports = __webpack_public_path__ + "static/media/icon-good-luck.5a4e1ee9.png";